import React from 'react';

export const SkeletonBox = ({ className = '' }) => (
  <div className={`bg-zinc-800/50 rounded-lg animate-pulse ${className}`} />
);

export const SkeletonText = ({ className = '', width = 'w-32' }) => (
  <div className={`bg-zinc-800/50 rounded h-4 animate-pulse ${width} ${className}`} />
);

export const SkeletonCard = ({ className = '' }) => (
  <div className={`bg-zinc-900/50 border border-white/5 rounded-2xl p-5 space-y-3 ${className}`}>
    <div className="flex items-center gap-3">
      <SkeletonBox className="w-12 h-12 rounded-xl" />
      <div className="space-y-2 flex-1">
        <SkeletonText width="w-40" />
        <SkeletonText width="w-24" />
      </div>
    </div>
    <SkeletonBox className="h-3 w-full rounded" />
    <SkeletonBox className="h-3 w-3/4 rounded" />
  </div>
);

export const DashboardSkeleton = () => (
  <div className="min-h-screen bg-[#050505] pb-24 px-4 pt-6 space-y-6">
    <div className="flex items-center gap-4">
      <SkeletonBox className="w-16 h-16 rounded-full" />
      <div className="space-y-2 flex-1">
        <SkeletonText width="w-48" className="h-6" />
        <SkeletonText width="w-32" />
      </div>
    </div>
    <div className="grid grid-cols-2 gap-4">
      <SkeletonCard />
      <SkeletonCard />
    </div>
    <SkeletonCard />
    <SkeletonCard />
  </div>
);

export const WorkoutSkeleton = () => (
  <div className="min-h-screen bg-[#050505] pb-24 px-4 pt-6 space-y-4">
    <div className="flex items-center gap-3 mb-6">
      <SkeletonBox className="w-8 h-8 rounded" />
      <SkeletonText width="w-48" className="h-8" />
    </div>
    {[1, 2, 3].map(i => (
      <div key={i} className="bg-zinc-900/50 border border-white/5 rounded-2xl p-5">
        <div className="flex items-center gap-3">
          <SkeletonBox className="w-12 h-12 rounded-xl" />
          <div className="space-y-2 flex-1">
            <SkeletonText width="w-56" className="h-5" />
            <SkeletonText width="w-32" />
          </div>
          <SkeletonBox className="w-10 h-10 rounded-lg" />
        </div>
      </div>
    ))}
  </div>
);

export const FeedSkeleton = () => (
  <div className="min-h-screen bg-[#050505] pb-24 px-4 pt-6 space-y-4 max-w-2xl mx-auto">
    <div className="flex items-center justify-between mb-6">
      <SkeletonText width="w-48" className="h-10" />
      <SkeletonBox className="w-28 h-10 rounded-lg" />
    </div>
    {[1, 2].map(i => (
      <div key={i} className="bg-zinc-900/50 border border-white/5 rounded-2xl overflow-hidden">
        <div className="p-4 flex items-center gap-3">
          <SkeletonBox className="w-12 h-12 rounded-full" />
          <div className="space-y-2 flex-1">
            <SkeletonText width="w-32" />
            <SkeletonText width="w-24" />
          </div>
        </div>
        <SkeletonBox className="w-full h-64" />
        <div className="p-4 space-y-2">
          <SkeletonText width="w-full" />
          <div className="flex gap-4 pt-2">
            <SkeletonBox className="w-16 h-6 rounded" />
            <SkeletonBox className="w-16 h-6 rounded" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export const ListSkeleton = ({ count = 5 }) => (
  <div className="space-y-3">
    {Array.from({ length: count }, (_, i) => (
      <div key={i} className="bg-zinc-900/50 border border-white/5 rounded-xl p-4 flex items-center gap-3">
        <SkeletonBox className="w-10 h-10 rounded-full" />
        <div className="space-y-2 flex-1">
          <SkeletonText width="w-40" />
          <SkeletonText width="w-24" />
        </div>
        <SkeletonBox className="w-20 h-8 rounded-lg" />
      </div>
    ))}
  </div>
);
